import React from 'react';
import { Workflow } from '../../../containers/workflow/interfaces/workflow';
import { WorkflowStatusEnum } from '../../../containers/workflow/interfaces/workflow-status';
import WorkflowAPI from '../../../containers/workflow/api/WorkflowAPI';
import { GlobalSearchItem, GlobalSearchRegistryItem } from '../../interfaces/global-search';
import { GenericListItemContent } from './GenericListItemContent/GenericListItemContent';
import { _teamSettingsService } from '../../../core/services/team-settings.service';

export const GLOBAL_SEARCH_WORKFLOW_KEY = 'workflows';

export const GlobalSearchWorkflowRegistry: GlobalSearchRegistryItem = {
  key: GLOBAL_SEARCH_WORKFLOW_KEY,
  title: 'Workflows',
  maxItemsWhenNoFiltersApplied: 2,
  sortOrder: 6,
  filters: [
    {
      label: 'Workflows',
      value: GLOBAL_SEARCH_WORKFLOW_KEY
    }
  ],
  viewAllRoute: '/workflow',
  inMemoryFiltering: true,
  doNotRender: () => !_teamSettingsService?.isWorkflowsEnabled(),
  dataResolver: () => WorkflowAPI.getWorkflows(false)
      .then(res => {
        const workflows = res.filter(
          workflow => workflow.status.value !== WorkflowStatusEnum.DRAFT.value
        ).map(GlobalSearchWorkflowFactory);

        return [...workflows];
      }),
  renderItem: (item) => (
    <GenericListItemContent primaryText={item.name} suffixIcon={item.icon} />
  )
};

export function GlobalSearchWorkflowFactory(
  workflow: Workflow
): GlobalSearchItem {
  let route = `/workflow/${ workflow.seqId }/overview`;

  if (workflow.status.value === WorkflowStatusEnum.DRAFT.value) {
    route = `/workflow/draft/${ workflow.seqId }`;
  }

  return {
    data: {},
    name: workflow.name,
    key: `workflow-${workflow.id}`,
    exitURL: route,
    icon: 'workflow',
    searchKeywords: [workflow.name]
  };
}
